var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("fieldset", [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-layout" },
        [
          _c("div", { staticClass: "mb20" }, [
            _c(
              "label",
              { staticClass: "mr20" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.goodsFlag,
                      callback: function($$v) {
                        _vm.goodsFlag = $$v
                      },
                      expression: "goodsFlag"
                    }
                  },
                  [_vm._v("商品")]
                )
              ],
              1
            ),
            _vm._v(" "),
            !_vm.vendor
              ? _c(
                  "label",
                  { staticClass: "mr20" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { hidden: "hidden" },
                        model: {
                          value: _vm.serviceFlag,
                          callback: function($$v) {
                            _vm.serviceFlag = $$v
                          },
                          expression: "serviceFlag"
                        }
                      },
                      [_vm._v("服务")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "callBidGoods",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.callBidGoods,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _vm.goodsFlag
                ? _c("div", [
                    _c("table", { staticClass: "custom-tbl" }, [
                      _c("thead", { staticClass: "head" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c("th", { attrs: { width: "" } }, [
                            _vm._v("产品名称")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "100" } }, [
                            _vm._v("采购数量")
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("单位")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("质保期(月)")]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "40%" } }, [
                            _vm._v("商品描述")
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("操作")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        { staticClass: "body" },
                        _vm._l(_vm.callBidDoc.callBidGoodsList, function(
                          callBidGoods,
                          index
                        ) {
                          return _c("tr", { staticClass: "row" }, [
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "callBidGoodsList." + index + ".name"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: callBidGoods.name,
                                        callback: function($$v) {
                                          _vm.$set(callBidGoods, "name", $$v)
                                        },
                                        expression: "callBidGoods.name"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "callBidGoodsList." +
                                        index +
                                        ".quantity"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: callBidGoods.quantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            callBidGoods,
                                            "quantity",
                                            $$v
                                          )
                                        },
                                        expression: "callBidGoods.quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "callBidGoodsList." + index + ".unit"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: callBidGoods.unit,
                                        callback: function($$v) {
                                          _vm.$set(callBidGoods, "unit", $$v)
                                        },
                                        expression: "callBidGoods.unit"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "callBidGoodsList." +
                                        index +
                                        ".wrntPeriod"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: callBidGoods.wrntPeriod,
                                        callback: function($$v) {
                                          _vm.$set(
                                            callBidGoods,
                                            "wrntPeriod",
                                            $$v
                                          )
                                        },
                                        expression: "callBidGoods.wrntPeriod"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "callBidGoodsList." + index + ".desc"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: callBidGoods.desc,
                                        callback: function($$v) {
                                          _vm.$set(callBidGoods, "desc", $$v)
                                        },
                                        expression: "callBidGoods.desc"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteTplVar(index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              )
                            ])
                          ])
                        })
                      ),
                      _vm._v(" "),
                      _c("tfoot", { staticClass: "foot" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c("td", { attrs: { colspan: "6" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.showInput()
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon iconfont icon-jiahao"
                                }),
                                _c("span", [_vm._v("添加商品")])
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "callBidServc",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.callBidServc,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _vm.serviceFlag
                ? _c("div", [
                    _c("table", { staticClass: "custom-tbl" }, [
                      _c("thead", { staticClass: "head" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c("th", { attrs: { width: "" } }, [
                            _vm._v("服务名称")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "60%" } }, [
                            _vm._v("服务描述")
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("操作")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        { staticClass: "body" },
                        _vm._l(_vm.callBidDoc.callBidServcList, function(
                          callBidServc,
                          index
                        ) {
                          return _c("tr", { staticClass: "row" }, [
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "callBidServcList." + index + ".name"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: callBidServc.name,
                                        callback: function($$v) {
                                          _vm.$set(callBidServc, "name", $$v)
                                        },
                                        expression: "callBidServc.name"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "callBidServcList." + index + ".desc"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: callBidServc.desc,
                                        callback: function($$v) {
                                          _vm.$set(callBidServc, "desc", $$v)
                                        },
                                        expression: "callBidServc.desc"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteTplVar1(index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              )
                            ])
                          ])
                        })
                      ),
                      _vm._v(" "),
                      _c("tfoot", { staticClass: "foot" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c(
                            "td",
                            {
                              staticClass: "align center",
                              staticStyle: {
                                padding: "10px",
                                border: "1px solid #eee",
                                "text-align": "center"
                              },
                              attrs: { colspan: "3" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.showInput1()
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon iconfont icon-jiahao"
                                  }),
                                  _c("span", [_vm._v("添加服务")])
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-caption dashed font18 required dashed",
        staticStyle: { "background-color": "#fff" }
      },
      [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("需求详情")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-094e970c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094e970c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/CreateCallItem.vue
// module id = 3342
// module chunks = 0